(function () {
  'use strict';

  function init() {
    var ROOT = document.getElementById('unoo-product');
    if (!ROOT) return;

    var mainImg = document.getElementById('unoo-main-img');

    // ── Gallery zoom on main image ──
    var wrap = ROOT.querySelector('.unoo-hero-image-wrap');
    var zoomScale = 2.2;
    var zoomed = false;

    if (wrap && mainImg) {
      // Toggle zoom on click
      wrap.addEventListener('click', function (e) {
        // ignore clicks on thumbnails area (handled separately)
        if (e.target.closest('.unoo-thumbnails')) return;
        zoomed = !zoomed;
        if (zoomed) {
          wrap.classList.add('unoo-zoomed');
          moveZoom(e);
        } else {
          wrap.classList.remove('unoo-zoomed');
          mainImg.style.transform = 'scale(1) translate(0,0)';
        }
      });

      // Follow mouse when zoomed
      wrap.addEventListener('mousemove', function (e) {
        if (!zoomed) return;
        moveZoom(e);
      });

      // Reset on mouse leave
      wrap.addEventListener('mouseleave', function () {
        if (!zoomed) return;
        mainImg.style.transform = 'scale(' + zoomScale + ') translate(0,0)';
      });

      function moveZoom(e) {
        var rect = wrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width - 0.5) * 100;
        var y = ((e.clientY - rect.top) / rect.height - 0.5) * 100;
        // clamp so image doesn't pan out of bounds
        var limit = ((zoomScale - 1) / zoomScale) * 50;
        x = Math.max(-limit, Math.min(limit, x));
        y = Math.max(-limit, Math.min(limit, y));
        mainImg.style.transform = 'scale(' + zoomScale + ') translate(' + (-x) + '%,' + (-y) + '%)';
      }
    }

    // ── Gallery: event delegation on both thumbnail rows ──
    ROOT.querySelectorAll('.unoo-thumbnails').forEach(function (row) {
      row.addEventListener('click', function (e) {
        var thumb = e.target.closest('.unoo-thumb');
        if (!thumb) return;

        // get src from the <img> inside the thumb
        var img = thumb.querySelector('img');
        if (!img || !mainImg) return;

        // swap active state
        ROOT.querySelectorAll('.unoo-thumb').forEach(function (t) {
          t.classList.remove('unoo-active');
          t.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('unoo-active');
        thumb.setAttribute('aria-pressed', 'true');

        // swap main image
        mainImg.src = img.src;
        mainImg.alt = img.alt || 'Celine Luggage Nano Tote';
        // reset zoom on image switch
        zoomed = false;
        wrap.classList.remove('unoo-zoomed');
        mainImg.style.transform = 'scale(1) translate(0,0)';
      });
    });

    // ── Keyboard support for thumbnails ──
    ROOT.querySelectorAll('.unoo-thumb').forEach(function (thumb) {
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          thumb.click();
        }
      });
    });

    // ── FAQ Accordion ──
    ROOT.querySelectorAll('.unoo-faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.unoo-faq-item');
        var answer = item.querySelector('.unoo-faq-answer');
        var isOpen = item.classList.contains('unoo-open');

        // close all
        ROOT.querySelectorAll('.unoo-faq-item').forEach(function (el) {
          el.classList.remove('unoo-open');
          el.querySelector('.unoo-faq-answer').style.maxHeight = '0';
          el.querySelector('.unoo-faq-question').setAttribute('aria-expanded', 'false');
        });

        // open clicked if it was closed
        if (!isOpen) {
          item.classList.add('unoo-open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // ── Buy It Now — direct checkout ──
    var buyBtn = ROOT.querySelector('#unoo-buy-now');
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        // Use Shopify's permanent direct checkout URL with variant ID
        window.location.href = '/cart/' + '47522654912686' + ':1?checkout';
      });
    }

    // ── Add to Bag — Shopify Ajax Cart API ──
    var addBtn = ROOT.querySelector('#unoo-add-to-bag');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var originalHTML = addBtn.innerHTML;
        addBtn.disabled = true;
        addBtn.innerHTML = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: 47522654912686, quantity: 1 })
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function () {
          // Refresh Shopify cart drawer/count if theme supports it
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // Reload the page so the theme's cart count and drawer update
          window.location.reload();
        })
        .catch(function () {
          // Fallback: redirect to cart page
          window.location.href = '/cart';
        });
      });
    }
  }

  // Run after DOM is ready regardless of where the script tag sits
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
